import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const JobPostingTable = ({ jobs, sortConfig, onSort, onEdit, onDuplicate, onViewApplications, onArchive }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Active':
        return 'bg-success/10 text-success border-success/20';
      case 'Draft':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'Closed':
        return 'bg-muted text-muted-foreground border-border';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const getSortIcon = (column) => {
    if (sortConfig?.key !== column) {
      return <Icon name="ArrowUpDown" size={14} className="text-muted-foreground" />;
    }
    return sortConfig?.direction === 'asc' 
      ? <Icon name="ArrowUp" size={14} className="text-foreground" />
      : <Icon name="ArrowDown" size={14} className="text-foreground" />;
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="text-left p-4">
                <button
                  onClick={() => onSort('title')}
                  className="flex items-center space-x-2 font-medium text-foreground hover:text-primary transition-colors duration-150"
                >
                  <span>Job Title</span>
                  {getSortIcon('title')}
                </button>
              </th>
              <th className="text-left p-4">
                <button
                  onClick={() => onSort('department')}
                  className="flex items-center space-x-2 font-medium text-foreground hover:text-primary transition-colors duration-150"
                >
                  <span>Department</span>
                  {getSortIcon('department')}
                </button>
              </th>
              <th className="text-left p-4">
                <button
                  onClick={() => onSort('status')}
                  className="flex items-center space-x-2 font-medium text-foreground hover:text-primary transition-colors duration-150"
                >
                  <span>Status</span>
                  {getSortIcon('status')}
                </button>
              </th>
              <th className="text-left p-4">
                <button
                  onClick={() => onSort('applicationCount')}
                  className="flex items-center space-x-2 font-medium text-foreground hover:text-primary transition-colors duration-150"
                >
                  <span>Applications</span>
                  {getSortIcon('applicationCount')}
                </button>
              </th>
              <th className="text-left p-4">
                <button
                  onClick={() => onSort('createdAt')}
                  className="flex items-center space-x-2 font-medium text-foreground hover:text-primary transition-colors duration-150"
                >
                  <span>Created</span>
                  {getSortIcon('createdAt')}
                </button>
              </th>
              <th className="text-right p-4">
                <span className="font-medium text-foreground">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {jobs?.map((job) => (
              <tr key={job?.id} className="border-b border-border hover:bg-muted/30 transition-colors duration-150">
                <td className="p-4">
                  <div>
                    <h3 className="font-medium text-foreground">{job?.title}</h3>
                    <div className="flex items-center space-x-3 mt-1 text-sm text-muted-foreground">
                      <div className="flex items-center space-x-1">
                        <Icon name="MapPin" size={12} />
                        <span>{job?.location}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="Clock" size={12} />
                        <span>{job?.type}</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td className="p-4">
                  <span className="text-foreground">{job?.department}</span>
                </td>
                <td className="p-4">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium border ${getStatusColor(job?.status)}`}>
                    {job?.status}
                  </span>
                </td>
                <td className="p-4">
                  <span className="text-foreground font-medium">{job?.applicationCount}</span>
                </td>
                <td className="p-4">
                  <span className="text-muted-foreground">{formatDate(job?.createdAt)}</span>
                </td>
                <td className="p-4">
                  <div className="flex items-center justify-end space-x-1">
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="Edit"
                      onClick={() => onEdit(job)}
                      className="h-8 w-8 p-0"
                    />
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="Copy"
                      onClick={() => onDuplicate(job)}
                      className="h-8 w-8 p-0"
                    />
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="Users"
                      onClick={() => onViewApplications(job)}
                      className="h-8 w-8 p-0"
                    />
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="Archive"
                      onClick={() => onArchive(job)}
                      className="h-8 w-8 p-0 text-muted-foreground hover:text-error"
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default JobPostingTable;